import { PageConfig } from "@hub/models/ui/page-config";
import Head from "next/head";
import React from "react";

export const PageContainer: React.FC<PageConfig> = ({
  children,
  title,
  description,
  structuredData,
  canonicalUrl,
  headMetadata,
}) => {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        {headMetadata && (
          <>
            <meta property="og:site_name" content="Auth0 Developer Resources" />
            <meta property="og:title" content={headMetadata.title} />
            <meta
              property="og:description"
              content={headMetadata.description}
            />
            <meta property="og:url" content={headMetadata.url} />
            <meta property="og:type" content={headMetadata.type} />
            {headMetadata.image && (
              <meta property="og:image" content={headMetadata.image} />
            )}
          </>
        )}
        {headMetadata && (
          <>
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@auth0" />
            <meta name="twitter:title" content={headMetadata.title} />
            <meta
              name="twitter:description"
              content={headMetadata.description}
            />
            <meta name="twitter:url" content={headMetadata.url} />
            {headMetadata.image && (
              <meta name="twitter:image" content={headMetadata.image} />
            )}
          </>
        )}
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
          />
        )}
      </Head>
      <>{children}</>
    </>
  );
};
